$(document).ready(function(){

    $('.menu-open').click(function(){
        $('#menu').removeClass('slideOutRight').addClass('slideInRight').css('display', 'block');
        $('body').addClass('menu-active');
    });

    $('.menu-close').click(function(){
        $('#menu').removeClass('slideInRight').addClass('slideOutRight').css('display', 'none');
        $('body').removeClass('menu-active');
    });

    $(document).mouseup(function (e)
    {
        var container = $("#menu");

        if (!container.is(e.target) // if the target of the click isn't the container...
            && container.has(e.target).length === 0) // ... nor a descendant of the container
        {
            $('#menu').removeClass('slideInRight').addClass('slideOutRight').css('display', 'none');
            $('body').removeClass('menu-active');
        }
    });

});